import {TodoDb} from './todoDbSchema';
import {TodoWrite} from './todoWriteSchema';
import {FirestoreTimestamp} from '../_other/firestore/firestoreTimestampSchema';

export function mapTodoWriteToDb(todoWrite: TodoWrite, timestamp: FirestoreTimestamp): TodoDb {
  return {
    ...todoWrite,
    createdAt: timestamp,
    updatedAt: timestamp,
  };
}
